<template>
  <el-popover :placement="placement" popper-class="g__el-popover-no-padding" :trigger="trigger" v-model="popoverVisible">
    <template #reference>
      <slot>
        <el-button v-auto-blur :type="buttonType" class="hc-dropdown__ref-default-button">
          <div class="ref-content-box">
            {{ buttonLabel }}
            <!-- icon arrow -->
            <!-- <i style="font-size: 8px" :class="iconArrowClass"></i> -->
            <svg-icon
              style="font-size: 8px;margin-left: 4px;"
              :icon-class="svgIconClassName"
            />
          </div>

        </el-button>
      </slot>
    </template>

    <slot name="dropdown"></slot>
  </el-popover>
</template>

<script>
import { injectionKeyCommandHandler } from './keys'

export default {
  name: 'HcDropdown',
  provide() {
    return {
      [injectionKeyCommandHandler]: this.handleCommand
    }
  },
  props: {
    buttonLabel: {
      type: String,
      default: '点击下拉'
    },
    buttonType: {
      type: String,
      default: 'default',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    hideOnClick: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

  },
  emits: ['command'],
  data() {
    return {
      popoverVisible: false
    }
  },
  computed: {
    iconArrowClass() {
      return [
        'iconhuice',
        this.popoverVisible ? 'icon-arrow-up' : 'icon-arrow-down'
      ]
    },
    svgIconClassName() {
      return this.popoverVisible ? 'icon-arrow-up' : 'icon-arrow-down'
    }
  },
  methods: {
    handleCommand(cmd) {
      if (this.hideOnClick) {
        this.popoverVisible = false
      }

      this.$emit('command', cmd)
    }
  },
}
</script>

<style lang="scss" scoped>
  .hc-dropdown__ref-default-button {
    padding: 9px 8px 9px 12px;
  }

  .ref-content-box {
    display: flex;
    align-items: center;
  }
</style>

<style lang="scss">
.g__el-popover-no-padding {
  padding: 0 !important;
}
</style>
